import { Stack } from '@mantine/core';
import { FC } from 'react';
import { Patient } from '@medplum/fhirtypes';
import { PatientSummary } from './patient-summary/PatientSummary';
import { CurrentEncounterManager } from './CurrentEncounterManager';
import { useCurrentEncounter } from '@/hooks/useCurrentEncounter';
import { LoaderWithChildren } from '@/components/LoaderWithChildren';

interface Props {
  patient: Patient;
}

export const PatientDemographicsAndActions: FC<Props> = ({ patient }) => {
  const { currentEncounter, loading, setCurrentEncounter } =
    useCurrentEncounter(patient);

  return (
    <Stack gap="md" w="350px" px="sm" mt="xl">
      <LoaderWithChildren isLoading={loading}>
        <>
          <CurrentEncounterManager
            patient={patient}
            currentEncounter={currentEncounter}
            setCurrentEncounter={setCurrentEncounter}
          />
          <PatientSummary patient={patient} headerDisabled />
        </>
      </LoaderWithChildren>
    </Stack>
  );
};
